export const environment = {
  production: false,
  root_uri: "https://dev.kingtrivia.com",
  api_root: "https://dev.kingtrivia.com",
  host: "dev.kingtrivia.com",
  ws: { protocol: "wss" }
};